import { Howl, Howler } from "howler";
import { SliderManager } from "./SliderOperator";

let rideSound = null;
let rideSoundUrl = null;

let ridePos = { x: 0, y: 0, z: 0 };
let targetPos = { x: 0, y: 0, z: 0 };

let interpInterval = null;
let currentPitch = 1;
let pitchTarget = 1;
let fluctuationPhase = 0;

export const RideAudioManager = {
  handleRideStart(url, speed, relX, relY, relZ) {
    if (rideSound) this.handleRideStop();

    
    const minRate = 0.85;
    const maxRate = 1.25;
    const maxSpeed = 100;

    pitchTarget = minRate + (speed / maxSpeed) * (maxRate - minRate);
    pitchTarget = Math.min(Math.max(pitchTarget, minRate), maxRate);
    currentPitch = pitchTarget;

    rideSoundUrl = url;
    rideSound = new Howl({
      src: [url],
      html5: false,
      loop: true,
      volume: SliderManager.volumeEffects * SliderManager.volumeMaster,
      rate: currentPitch,
      onplayerror: () => rideSound.once("unlock", () => rideSound.play())
    });

    rideSound.once("play", () => {
      
      Howler.pos(0, 0, 0);
      Howler.orientation(0, 0, -1, 0, 1, 0);

      ridePos = { x: relX, y: relY, z: relZ };
      targetPos = { x: relX, y: relY, z: relZ };

      const soundObj = rideSound._sounds[0];
      if (soundObj && soundObj._panner) {
        const p = soundObj._panner;
        p.panningModel = "HRTF";
        p.distanceModel = "linear";
        p.refDistance = 5;
        p.maxDistance = 30;
        p.rolloffFactor = 2.0;
      }

      rideSound.pos(relX, relY, relZ);

      if (interpInterval) clearInterval(interpInterval);
      interpInterval = setInterval(() => {
        if (!rideSound) return;

       
        ridePos.x += (targetPos.x - ridePos.x) * 0.15;
        ridePos.y += (targetPos.y - ridePos.y) * 0.15;
        ridePos.z += (targetPos.z - ridePos.z) * 0.15;
        rideSound.pos(ridePos.x, ridePos.y, ridePos.z);

        
        currentPitch += (pitchTarget - currentPitch) * 0.05;

        
        fluctuationPhase += 0.05;
        const fluctuation = Math.sin(fluctuationPhase) * 0.02; // kleine Schwankung ±0.02

        rideSound.rate(currentPitch + fluctuation);
      }, 50);
    });

    rideSound.play();
  },

  handleRideUpdate(relX, relY, relZ, yaw, pitch, speed) {
    if (!rideSound) return;

    targetPos = { x: relX, y: relY, z: relZ };

    const minRate = 0.85;
    const maxRate = 1.25;
    const maxSpeed = 100;

    pitchTarget = minRate + (speed / maxSpeed) * (maxRate - minRate);
    pitchTarget = Math.min(Math.max(pitchTarget, minRate), maxRate);

    rideSound.volume(SliderManager.volumeEffects * SliderManager.volumeMaster);
  },

  handleRideStop() {
    if (!rideSound) return;

    this.fadeOut(rideSound, () => {
      try { rideSound.stop(); } catch {}
      try { rideSound.unload(); } catch {}
      rideSound = null;
      rideSoundUrl = null;
      if (interpInterval) clearInterval(interpInterval);
      interpInterval = null;
    });
  },

  updateRideVolumeOnSlider() {
    if (rideSound) {
      rideSound.volume(SliderManager.volumeEffects * SliderManager.volumeMaster);
    }
  },

  fadeOut(audio, callback) {
    const steps = 10;
    const interval = 200;
    let index = 0;
    const startVol = audio.volume();

    const fader = setInterval(() => {
      index++;
      audio.volume(startVol * (1 - index / steps));
      if (index >= steps) {
        clearInterval(fader);
        if (callback) callback();
      }
    }, interval);
  }
};
